import { CfdiUseCode } from './user-profile.type';

/** Doctor submission waiting for an admin to register it, or already registered. */
export type InvoicingRequestStatus = 'pending' | 'verified';

export interface InvoicingRequest {
  uid: string;
  businessId: string;
  businessName: string;
  cfdiUse: CfdiUseCode;
  status: InvoicingRequestStatus;
  csfPath: string;
  certificatePath: string;
  privateKeyPath: string;
  passwordPath: string;
  submittedAt: Date | null;
  verifiedAt: Date | null;
}

export function invoicingStoragePaths(businessId: string, uid: string): {
  csf: string;
  certificate: string;
  privateKey: string;
  password: string;
} {
  const base = `invoicing/${businessId}/${uid}`;
  return {
    csf: `${base}/constancia.pdf`,
    certificate: `${base}/efirma.cer`,
    privateKey: `${base}/efirma.key`,
    password: `${base}/efirma-password.txt`,
  };
}
